import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './design/theme/ThemeProvider';
import { Header } from './components/layout/Header/Header';
import { Footer } from './components/layout/Footer/Footer';
import { CartDrawer } from './components/cart/CartDrawer/CartDrawer';
import { ScanlineEffect } from './components/shared/effects/ScanlineEffect';
import { Home } from './pages/Home/Home';
import { Shop } from './pages/Shop/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { UpdatePassword } from './pages/UpdatePassword';
import { ForgotPassword } from './pages/ForgotPassword';
import { Account } from './pages/Account';
import { useLoadProducts } from './hooks/useLoadProducts';
import { useSkuInputHandler } from './hooks/useSkuInputHandler';
import { SkuValidationModal } from './utils/skuHelpers/SkuValidationModal';

function App() {
  // Load products on app mount
  useLoadProducts();

  // SKU validation state for inventory debugging
  const [skuDebugMode, setSkuDebugMode] = useState(false);

  // Input handler for SKU validation shortcuts
  useSkuInputHandler(() => {
    setSkuDebugMode(true);
  });

  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen bg-white text-gray-900 flex flex-col relative">
          {/* Scanline effect for gaming aesthetic */}
          <ScanlineEffect />

          <Header />

          <main className="flex-1 relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/account" element={<Account />} />
              <Route path="/update-password" element={<UpdatePassword />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/downloads" element={<div className="container mx-auto px-4 py-16"><h1 className="text-4xl">Downloads - Coming Soon</h1></div>} />
              <Route path="/about" element={<div className="container mx-auto px-4 py-16"><h1 className="text-4xl">About - Coming Soon</h1></div>} />
              <Route path="*" element={<div className="container mx-auto px-4 py-16"><h1 className="text-4xl">404 - Page Not Found</h1></div>} />
            </Routes>
          </main>

          <Footer />
          <CartDrawer />

          {/* SKU validation modal for inventory debugging */}
          {skuDebugMode && <SkuValidationModal onClose={() => setSkuDebugMode(false)} />}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
